import { render, staticRenderFns } from "./ImageCarousel3.vue?vue&type=template&id=74fecb3a&scoped=true"
import script from "./ImageCarousel3.vue?vue&type=script&lang=js"
export * from "./ImageCarousel3.vue?vue&type=script&lang=js"
import style0 from "./ImageCarousel3.vue?vue&type=style&index=0&id=74fecb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fecb3a",
  null
  
)

export default component.exports